import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const truckMakesAdapter = getAdapter();

const truckMakesSlice = createSlice({
  name: 'truckMakes',
  initialState: truckMakesAdapter.getInitialState(),
  reducers: {
    setTruckMakes: (state, { payload: { truckMakes } }) => {
      truckMakesAdapter.setAll(state, truckMakes);
    }
  }
});

const selectors = truckMakesAdapter.getSelectors(({ truckMakes }) => truckMakes);

export const getTruckMakesIncludingDeleted = state => selectors.selectAll(state);

export const getTruckMakes = state => getTruckMakesIncludingDeleted(state).filter(({ deleted }) => !deleted);

export const { setTruckMakes } = truckMakesSlice.actions;

export default truckMakesSlice.reducer;
